import React, { useState, useContext, useEffect } from 'react';
// import { Link } from 'react-router-dom';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import DatePicker from 'react-datepicker';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck, faIdCardAlt, faSearch, faMicrophone, faMicrophoneSlash } from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import { ThemeContext } from '../Common/ThemeProvider';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import 'react-tabs/style/react-tabs.css';
import Goods from '../Common/CFTGoodsList';
import VehicleChart from '../Common/VehicleChart';
import * as yup from 'yup';
import Select from 'react-select';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';
import SurveyPreview from './SurveyPreview';
import SurveyVehicleChart from './SurveyVehicleChart';
import SpeechRecognition, {
    useSpeechRecognition,
} from "react-speech-recognition";

const customerDefault = {
    Name: "",
    CompanyName: "",
    PhoneNumber: 0,
    EmailID: "",
    OriginAddress: "",
    OriginCity: "",
    OriginState: "",
    OriginPincode: 0,
    OriginCountry: "India",
    OriginFloor: 0,
    DestinationAddress: "",
    DestinationCity: "",
    DestinationState: "",
    DestinationPincode: 0,
    DestinationCountry: "India",
    DesinationFloor: 0,
    PreferredDeliveryDate: null,
    PreferredPackingDate: null,
    PreferredMovingDate: null,
    OriginHasLift: 0,
    DestinationHasLift: 0,
    IBAApproval: 0,
    IsSurveyClosed: 0,
    SurveyID: 0,
    IsInsured: 0,
    InsuranceType: 0,
    InsuranceAmount: 0,
    DestinationType: 0,
    IsGSTAvailable: 0,
    GSTNumber: "",
    Status: 1,
    IsDeleted: 0
};

const Destination = [
    {
        label: "Local",
        value: 2
    },
    {
        label: "Domestic",
        value: 1
    },

    {
        label: "International",
        value: 3
    }];

const CustomerSchema = yup.object().shape({
    PreferredMovingDate: yup.date().typeError('Enter Valid Moving Date').nullable(false).required('Enter Valid Delivery Date'),
    PreferredPackingDate: yup.date().typeError('Enter Valid Packing Date').nullable(false).required('Enter Valid Delivery Date'),
    PreferredDeliveryDate: yup.date().typeError('Enter Valid Delivery Date').nullable(false).required('Enter Valid Delivery Date'),
    DestinationType: yup.number().required(),
    OriginAddress: yup.string().trim().required(),
    OriginCountry: yup.string().trim().required(),
    OriginPincode: yup.number().required(),
    OriginState: yup.string().trim().required(),
    OriginCity: yup.string().trim().required(),
    DestinationAddress: yup.string().trim().required(),
    DestinationCountry: yup.string().trim().required(),
    DestinationPincode: yup.number().required(),
    DestinationState: yup.string().trim().required(),
    DestinationCity: yup.string().trim().required(),
    EmailID: yup.string().trim().required().email(),
    PhoneNumber: yup.number().typeError('Enter Valid Phone Number').required().min(10, 'Phone Number should be 10 digit'),
    Name: yup.string().required('Enter Valid Name').required(),
});




const Survey = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [customerData, setcustomerData] = useState(customerDefault);
    const [FurnitureDisplay, setFurnitureDisplay] = useState("none");
    const [ElectronicsDisplay, setElectronicsDisplay] = useState("none");
    const [BedRoomDisplay, setBedRoomDisplay] = useState("none");
    const [OthersDisplay, setOthersDisplay] = useState("none");
    const [displaySurveyPreview, setdisplaySurveyPreview] = useState("none");
    const [displayVehicleChart, setdisplayVehicleChart] = useState("none");
    const [GoodsState, setGoodsState] = useState([]);
    const [CFTTotal, setCFTTotal] = useState(0);
    const [VehicleRequired, setVehicleRequired] = useState("NA");
    const [userData, setuserData] = useState(null);
    const [ServiceType, setServiceType] = useState({ value: null, label: null });
    const [Customers, setCustomers] = useState([]);
    const [CustomersInfo, setCustomersInfo] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState({ value: null, label: null });
    const [SearchOption, setSearchOption] = useState(0);
    const [SearchGoods, setSearchGoods] = useState([]);
    const [SelectedTab, setSelectedTab] = useState(1);
    const [SpeechText, setSpeechText] = useState(0);
    const [EnableSpeech, setEnableSpeech] = useState(0);

    useEffect(() => {
        if (navigator.userAgent.indexOf("Chrome") !== -1 || navigator.userAgent.indexOf("Safari") !== -1 ||
            (navigator.userAgent.indexOf("MSIE") !== -1) || (!!document.documentMode === true)) {
            setEnableSpeech(1);
        }
        setuserData(localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null);
        FetchSurvey();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const commands = [
        {
            command: 'Name *',
            callback: (name) => {
                setcustomerData({ ...customerData, "Name": name });
            }
        },
        {
            command: 'Company *',
            callback: (company) => {
                setcustomerData({ ...customerData, "CompanyName": company });
            }
        },
        {
            command: 'Email *',
            callback: (email) => {
                setcustomerData({ ...customerData, "EmailID": email });
            }
        },
        {
            command: 'Origin Address *',
            callback: (originAdd) => {
                setcustomerData({ ...customerData, "OriginAddress": originAdd });
            }
        },
        {
            command: 'Destination Address *',
            callback: (destAdd) => {
                setcustomerData({ ...customerData, "DestinationAddress": destAdd });
            }
        },
        {
            command: 'Origin Country *',
            callback: (country) => {
                setcustomerData({ ...customerData, "OriginCountry": country });
            }
        },
        {
            command: 'Destination Country *',
            callback: (country) => {
                setcustomerData({ ...customerData, "DestinationCountry": country });
            }
        },
        {
            command: 'Origin State *',
            callback: (state) => {
                setcustomerData({ ...customerData, "OriginState": state });
            }
        },
        {
            command: 'Destination State *',
            callback: (state) => {
                setcustomerData({ ...customerData, "DestinationState": state });
            }
        },
        {
            command: 'Origin City *',
            callback: (city) => {
                setcustomerData({ ...customerData, "OriginCity": city });
            }
        },
        {
            command: 'Destination City *',
            callback: (city) => {
                setcustomerData({ ...customerData, "DestinationCity": city });
            }
        },
        {
            command: 'Origin Pincode *',
            callback: (pincode) => {
                setcustomerData({ ...customerData, "OriginPincode": pincode });
            }
        },
        {
            command: 'Destination Pincode *',
            callback: (pincode) => {
                setcustomerData({ ...customerData, "DestinationPincode": pincode });
            }
        },
        {
            command: 'Is (GST) Available *',
            callback: (gst) => {
                setcustomerData({ ...customerData, "IsGSTAvailable": (gst?.toLowerCase() === "yes" ? 1 : 0) });
            }
        },
        {
            command: '(IBA) Approval *',
            callback: (iba) => {
                setcustomerData({ ...customerData, "IBAApproval": (iba?.toLowerCase() === "yes" ? 1 : 0) });
            }
        },
        {
            command: 'Origin Lift Available *',
            callback: (lift) => {
                setcustomerData({ ...customerData, "OriginHasLift": (lift?.toLowerCase() === "yes" ? 1 : 0) });
            }
        },
        {
            command: 'Destination Lift Available *',
            callback: (lift) => {
                setcustomerData({ ...customerData, "DestinationHasLift": (lift?.toLowerCase() === "yes" ? 1 : 0) });
            }
        },
        {
            command: 'Insurance Required *',
            callback: (ins) => {
                setcustomerData({ ...customerData, "IsInsured": (ins?.toLowerCase() === "yes" ? 1 : 0) });
            }
        },
        {
            command: 'Clear',
            callback: () => {
                setcustomerData(customerDefault);
            }
        },

        {
            command: 'Stop',
            callback: () => {
                SpeechRecognition.stopListening();
                setSpeechText(0);
            }
        },
    ];

    const {
        // eslint-disable-next-line no-unused-vars
        transcript,
        // eslint-disable-next-line no-unused-vars
        listening,
        // eslint-disable-next-line no-unused-vars
        resetTranscript
    } = useSpeechRecognition({ commands });





    const FetchSurvey = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData !== null) {
            Axiosfetch(baseURL + "GetActiveCustomersByPartnerID", "POST", {
                PartnerID: userData.OrganizationID,
                limit: 0,
                sorting: -1
            }, SurveySuccess, Failure);
        }
    };

    const SurveySuccess = (data) => {
        if (data.length > 0) {
            var customerData = [];
            setCustomersInfo(data);
            data.forEach(customer => {
                //if (customer.SurveyApproved === 1) {
                customerData.push({ label: "[#S" + customer.SurveyID + "-" + moment(customer.createdAt).local().format("DDMMYYYY") + "] " + customer.Name, value: customer._id })
                //}
            });

            setCustomers(customerData);

        }
    };

    const FetchGoodsSurvey = (cstmId) => {
        if (!IsUndefinedNullOrEmpty(cstmId)) {
            Axiosfetch(baseURL + "GetSurveyListByCustomerID", "POST", { CustomerID: cstmId }, GoodsSurveySuccess, Failure);
        }
    };

    const GoodsSurveySuccess = (data) => {
        if (data.length > 0) {
            let GoodsFinal = [];
            data.forEach(goods => {
                GoodsFinal.push({
                    Name: goods.Name,
                    GoodsID: goods.GoodsID,
                    Remarks: goods.Remarks,
                    CustomerID: data.CustomerID,
                    SurveyID: data.SurveyID,
                    Quantity: goods.Quantity,
                    CFTValue: goods.CFTValue
                });


                let remarks = document.getElementById("Remark" + goods.GoodsID);
                if (remarks !== undefined && remarks !== null) {
                    remarks.value = goods.Remarks;
                }

                document.getElementById("cft" + goods.GoodsID).innerText = goods.CFTValue * goods.Quantity;
            });

            let CFTTotalValue = 0;
            GoodsFinal.forEach(good => {
                CFTTotalValue += (good.CFTValue * good.Quantity);
            });

            setCFTTotal(CFTTotalValue);

            let vehcileData = VehicleChart.filter(v => v.MinCFT <= CFTTotalValue && v.MaxCFT >= CFTTotalValue);
            setVehicleRequired(vehcileData.length > 0 ? vehcileData[0].TypeOfLoad : "NA")


            setGoodsState(GoodsFinal);
        }
        else {
            setGoodsState([]);
        }
    };

    const onChangeCustomer = (customer) => {
        setSelectedCustomer({ value: (customer ? customer.value : null), label: (customer ? customer.label : null) });
        if (customer) {
            let CustomersData = CustomersInfo.filter(s => s._id === customer.value);
            if (CustomersData.length > 0) {
                let cstmr = CustomersData[0];

                cstmr.PreferredDeliveryDate = new Date(cstmr.PreferredDeliveryDate);
                cstmr.PreferredPackingDate = new Date(cstmr.PreferredPackingDate);
                cstmr.PreferredMovingDate = new Date(cstmr.PreferredMovingDate);
                var srvcType = Destination.filter(d => d.value === cstmr.DestinationType);
                setServiceType(srvcType[0]);
                setcustomerData(cstmr);
                FetchGoodsSurvey(customer.value);
            }
        }
        else {
            setServiceType({ value: null, label: null });
            setcustomerData(customerDefault);
        }
    };

    const onTextChange = (e) => {
        let value = e.target.value;
        setcustomerData({ ...customerData, [e.target.name]: value });
    };

    const OnLiftAvailableChange = (e) => {
        let isLiftAvailable = e.target.checked ? 1 : 0;
        setcustomerData({ ...customerData, [e.target.name]: isLiftAvailable });
    };

    const OnGSTCheckChange = (e) => {
        let isGSTAvailable = e.target.checked ? 1 : 0;
        setcustomerData({ ...customerData, [e.target.name]: isGSTAvailable });
    };

    const OnFunitureClick = () => {
        setFurnitureDisplay(FurnitureDisplay === "none" ? "block" : "none");
        setElectronicsDisplay("none");
        setBedRoomDisplay("none");
        setOthersDisplay("none");
    };

    const OnElectronicsClick = () => {
        setElectronicsDisplay(ElectronicsDisplay === "none" ? "block" : "none");
        setFurnitureDisplay("none");
        setBedRoomDisplay("none");
        setOthersDisplay("none");
    };

    const OnBedRoomClick = () => {
        setBedRoomDisplay(BedRoomDisplay === "none" ? "block" : "none");
        setFurnitureDisplay("none");
        setElectronicsDisplay("none");
        setOthersDisplay("none");
    };

    const OnOthersClick = () => {
        setOthersDisplay(OthersDisplay === "none" ? "block" : "none");
        setFurnitureDisplay("none");
        setElectronicsDisplay("none");
        setBedRoomDisplay("none");
    };

    const OnQuantityChange = (e) => {
        if (!isNaN(e.target.value)) {
            let Qty = parseInt(e.target.value === "" ? 0 : e.target.value);
            let GoodsName = e.target.name;
            let CFTData = parseInt(e.target.attributes.cft.nodeValue);
            let GoodsIDValue = parseInt(e.target.attributes.goodsid.nodeValue);
            var GoodsData = GoodsState;

            if (GoodsName !== "" && GoodsIDValue !== "" && Qty > 0) {
                let IsValueExist = GoodsData.filter(g => g.GoodsID === GoodsIDValue).length > 0;
                if (IsValueExist) {
                    let GoodsValue = GoodsData.filter(g => g.GoodsID !== GoodsIDValue);

                    let remarks = document.getElementById("Remark" + GoodsIDValue);
                    let remarksValue = "";
                    if (remarks !== undefined && remarks !== null) {
                        remarksValue = remarks.value;
                    }


                    GoodsValue.push({
                        Name: GoodsName,
                        GoodsID: GoodsIDValue,
                        Remarks: remarksValue,
                        Quantity: Qty,
                        CFTValue: CFTData
                    });

                    GoodsData = GoodsValue;

                    setGoodsState(GoodsValue);
                }
                else {
                    let remarks = document.getElementById("Remark" + GoodsIDValue);
                    let remarksValue = "";
                    if (remarks !== undefined && remarks !== null) {
                        remarksValue = remarks.value;
                    }

                    GoodsData.push({
                        Name: GoodsName,
                        Remarks: remarksValue,
                        GoodsID: GoodsIDValue,
                        Quantity: Qty,
                        CFTValue: CFTData
                    });

                    setGoodsState(GoodsData);
                }
                let CFTTotalValue = 0;
                GoodsData.forEach(good => {
                    CFTTotalValue += (good.CFTValue * good.Quantity);
                });

                setCFTTotal(CFTTotalValue);

                let vehcileData = VehicleChart.filter(v => v.MinCFT <= CFTTotalValue && v.MaxCFT >= CFTTotalValue);
                setVehicleRequired(vehcileData.length > 0 ? vehcileData[0].TypeOfLoad : "NA")

                document.getElementById("cft" + GoodsIDValue).innerText = CFTData * Qty;
            }
            else {
                document.getElementById("cft" + GoodsIDValue).innerText = 0;
                GoodsData = GoodsData.filter(g => g.GoodsID !== GoodsIDValue);
                let CFTTotalValue = 0;
                GoodsData.forEach(good => {
                    CFTTotalValue += (good.CFTValue * good.Quantity);
                });

                setCFTTotal(CFTTotalValue);

                let vehcileData = VehicleChart.filter(v => v.MinCFT <= CFTTotalValue && v.MaxCFT >= CFTTotalValue);
                setVehicleRequired(vehcileData.length > 0 ? vehcileData[0].TypeOfLoad : "NA")

                setGoodsState(GoodsData);
            }
        }
        else {
            e.target.value = "";
        }
    };

    const onDeliveryDateChange = (date) => {

        setcustomerData({ ...customerData, "PreferredDeliveryDate": date });
    };

    const OnDestinationChange = (DestData) => {
        let Dest = DestData ? DestData.value : "";
        if (DestData === null) {
            setServiceType({ value: null, label: null });
        }
        else {
            setServiceType(DestData);
        }

        if (Dest !== 0) {
            setcustomerData({ ...customerData, "DestinationType": Dest });
        }
    };

    const onPackingDateChange = (date) => {
        setcustomerData({ ...customerData, "PreferredPackingDate": date });
    };

    const onMovingDateChange = (date) => {
        setcustomerData({ ...customerData, "PreferredMovingDate": date });
    };

    const SaveSurvey = () => {
        if (customerData.IsInsured === 0) {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className={`custom-ui${CurrentTheme}`}>
                            <h3>Insurance Confirmation</h3>
                            <p>Are you sure you dont require Insurance ?</p>
                            <button type="button" style={{ fontSize: "1.4rem", marginRight: "10px" }} title="Updated Selected Quotation" className={`btn btn-Save ${CurrentTheme}Focus`} onClick={() => { SaveFinalSurvey(); onClose(); }}>Yes</button>
                            <button type="button" className="btn btn-default" onClick={onClose}>Close</button>
                        </div>
                    );
                }
            });
        }
        else {
            SaveFinalSurvey();
        }
    };

    const SaveFinalSurvey = () => {
        if (ValidateInsuranceIfChecked()) {
            CustomerSchema.validate(customerData).then(valid => {
                if (GoodsState.length > 0) {
                    if ((selectedCustomer.value !== null || moment(customerData.PreferredMovingDate) > moment()) &&
                        (selectedCustomer.value !== null || moment(customerData.PreferredPackingDate) > moment()) &&
                        (selectedCustomer.value !== null || moment(customerData.PreferredDeliveryDate) > moment()) &&
                        (selectedCustomer.value !== null || moment(customerData.PreferredDeliveryDate) < moment().add(30, 'days')) &&
                        moment(customerData.PreferredMovingDate).isSameOrAfter(customerData.PreferredPackingDate, 'day') &&
                        moment(customerData.PreferredDeliveryDate).isSameOrAfter(customerData.PreferredMovingDate, 'day') &&
                        moment(customerData.PreferredDeliveryDate).isSameOrAfter(customerData.PreferredPackingDate, 'day')) {
                        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;

                        var customer = customerData;
                        customer.PartnerID = userData !== null ? userData.OrganizationID : null;
                        customer.CreatedBy = userData !== null ? userData._id : null;
                        customer.PreferredPackingDate = moment.utc(customer.PreferredPackingDate);
                        customer.PreferredMovingDate = moment.utc(customer.PreferredMovingDate);
                        customer.PreferredDeliveryDate = moment.utc(customer.PreferredDeliveryDate);
                        customer.GSTNumber = customer.IsGSTAvailable ? customer.GSTNumber : "";

                        Axiosfetch(baseURL + (selectedCustomer.value === null ? "CreateCustomer" : "EditCustomer"), "POST", customer, CustomerSuccess, Failure);
                    }
                    else {
                        Alert.error("Packing / Delivery / Moving Date is Invalid", {
                            position: 'bottom-right',
                            effect: 'slide',
                            html: false
                        });
                    }
                }
                else {
                    Alert.error("Goods Details are missing", {
                        position: 'bottom-right',
                        effect: 'slide',
                        html: false
                    });
                }
            }).catch(err => {
                Alert.error(err.message, {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            });
        }
    };

    const ValidateInsuranceIfChecked = () => {
        let enqErr = "";
        if (customerData.OriginPincode !== 0 && !/^[1-9][0-9]{5}$/.test(customerData.OriginPincode.toString())) {
            enqErr = "Please enter valid Origin Pin code";
        }
        else if (customerData.DestinationPincode !== 0 && !/^[1-9][0-9]{5}$/.test(customerData.DestinationPincode.toString())) {
            enqErr = "Please enter valid Destination Pin code";
        }
        else if (customerData.DestinationType === 0) {
            enqErr = "Please enter Destination Type";
        }
        else if (customerData.IsGSTAvailable === 1 && customerData.GSTNumber === "") {
            enqErr = "Please enter GST Number";
        }
        else if (customerData.IsGSTAvailable === 1 && customerData.GSTNumber !== "" && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}Z[A-Z0-9]{1}?$/.test(customerData.GSTNumber.toString())) {
            enqErr = "Please enter valid GST Number";
        }
        else if (customerData.DestinationType === 1 && customerData.OriginCountry !== customerData.DestinationCountry) {
            enqErr = "Origin / Destination country cannot be different";
        }
        else if (customerData.DestinationType === 2 && (customerData.OriginCountry !== customerData.DestinationCountry
            || customerData.OriginState !== customerData.DestinationState)) {
            enqErr = "Origin / Destination Country and State cannot be different";
        }
        else if (customerData.IsInsured === 0) {
            return true;
        }
        else if (customerData.InsuranceType === 0) {
            enqErr = "Please enter Insurance Type";
        }
        else if (customerData.InsuranceAmount <= 0) {
            enqErr = "Please enter valid Amount";
        }

        if (enqErr !== "") {
            Alert.error(enqErr, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };

    const CustomerSuccess = (data) => {
        if (data._id !== undefined || data.success) {
            var GoodsFinal = [];
            GoodsState.forEach(goods => {
                GoodsFinal.push({
                    Name: goods.Name,
                    GoodsID: goods.GoodsID,
                    Remarks: goods.Remarks,
                    CustomerID: (selectedCustomer.value === null) ? data._id : selectedCustomer.value,
                    SurveyID: data.SurveyID,
                    Quantity: goods.Quantity,
                    CFTValue: goods.CFTValue
                });
            });

            if (selectedCustomer.value !== null) {
                Axiosfetch(baseURL + "DeleteGoodsSurvey", "POST", { customer: selectedCustomer.value }, DeleteSurveySuccess, Failure);
            }

            if (GoodsFinal.length > 0) {
                Axiosfetch(baseURL + "AddGoodsSurvey", "POST", GoodsFinal, AddSurveySuccess, Failure);
            }
        }
        else {
            Axiosfetch(baseURL + "DeleteCustomers", "POST", { ID: data }, AddSurveySuccess, Failure);
        }
    };

    const DeleteSurveySuccess = () => {
        // No Logic
    };

    const AddSurveySuccess = (data) => {
        if (data.success) {
            setcustomerData(customerDefault);

            var dd = document.querySelectorAll(".cftData");
            for (var i = 0; i < dd.length; i++) {
                dd[i].innerText = 0;
            }

            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const hideSurveyPreview = () => {
        setdisplaySurveyPreview("none");
    };

    const PreviewSurvey = () => {
        if (GoodsState.length > 0) {
            setdisplaySurveyPreview("block");
        }
        else {
            Alert.error("No Goods Selected", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnVehicleChartClick = () => {
        setdisplayVehicleChart("block");
    };

    const hideVehicleChart = () => {
        setdisplayVehicleChart("none");
    };

    const OnInsuranceChange = (e) => {
        switch (e.target.name) {
            case "IsInsured": setcustomerData({ ...customerData, [e.target.name]: e.target.checked ? 1 : 0 });
                break;
            case "InsuranceType": setcustomerData({ ...customerData, [e.target.name]: parseInt(e.target.value) });
                break;
            case "InsuranceAmount": setcustomerData({ ...customerData, [e.target.name]: parseFloat(e.target.value) });
                break;
            default: break;
        }
    };

    const onWebSiteClick = (website) => {
        if (website !== "") {
            window.open((website.indexOf("http") === -1 ? "http://" : "") + website);
        }
    };

    const onGoodsSearch = (searchValue) => {
        if (!IsUndefinedNullOrEmpty(searchValue)) {
            let totalList = [];
            let furinitureGoods = Goods.Furniture.filter(c => c.Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.Text.trim().toLowerCase().includes(searchValue.trim().toLowerCase()));
            let electronicGoods = Goods.Electronics.filter(c => c.Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.Text.trim().toLowerCase().includes(searchValue.trim().toLowerCase()));
            let bedroomGoods = Goods.BedRoom.filter(c => c.Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.Text.trim().toLowerCase().includes(searchValue.trim().toLowerCase()));
            let otherGoods = Goods.Others.filter(c => c.Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.Text.trim().toLowerCase().includes(searchValue.trim().toLowerCase()));

            if (furinitureGoods.length > 0) {
                totalList.push(...furinitureGoods);
            }
            if (electronicGoods.length > 0) {
                totalList.push(...electronicGoods);
            }
            if (bedroomGoods.length > 0) {
                totalList.push(...bedroomGoods);
            }
            if (otherGoods.length > 0) {
                totalList.push(...otherGoods);
            }
            setSearchGoods(totalList);
            setSearchOption(1);
        }
        else {
            setSearchGoods([]);
            setSearchOption(0);
        }
    };

    const Listener = () => {
        if (SpeechText === 0) {
            SpeechRecognition.startListening({ continuous: true });
        }
        else {
            SpeechRecognition.stopListening();
        }
        setSpeechText(SpeechText === 1 ? 0 : 1);
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show" style={{ overflow: "hidden" }}>
                <div className="row" style={{ marginBottom: "5px" }}>
                    <div className="col-md-3 col-12">
                        <div className="dropdownMobile" style={{ width: "90%" }}>
                            <Select value={selectedCustomer.value !== null ? selectedCustomer : ''} isClearable={true} isSearchable={true} placeholder="Edit Survey"
                                options={Customers}
                                onChange={onChangeCustomer}></Select>
                        </div>

                    </div>

                    <div className="col-md-4 col-12 align-center">
                        <h5 className="responsive-align" style={{ fontWeight: "500" }}>Goods Survey</h5>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-evenly" }} className="col-md-2 col-4 align-right">
                        <span data-tip="Vehicle Chart" className={`VehicleStyle ${CurrentTheme}Color`} onClick={OnVehicleChartClick}><FontAwesomeIcon icon={faTruck} /></span>
                        {userData !== null && (<div>
                            <span onClick={() => onWebSiteClick(window.location.hostname + `/UserVerification/${userData._id}`)} title="User ID Card" style={{ fontSize: "1.5rem" }} className={`${CurrentTheme}Color`}><FontAwesomeIcon icon={faIdCardAlt} /></span>
                        </div>)}
                    </div>
                    <div className={`${EnableSpeech === 1 ? "col-md-2" : "col-md-3"} col-4 align-right`}>
                        <button className={`btn btn-General ${CurrentTheme}Focus`} onClick={PreviewSurvey}>Preview</button>
                        <button className={`btn btn-General ${CurrentTheme}Focus`} onClick={SaveSurvey}>Submit</button>
                    </div>
                    <div style={{ display: (EnableSpeech === 1) ? "block" : "none" }} className="col-md-1 col-4">
                        <span className="cursor" data-tip="Speech To Text" onClick={Listener} style={{
                            fontSize: "20px", marginRight: "5px",
                            color: (SpeechText === 0 ? "green" : "red")
                        }}>
                            <FontAwesomeIcon icon={SpeechText === 0 ? faMicrophone : faMicrophoneSlash} /></span>
                    </div>
                </div>
                <div className="row" style={{ margin: "10px" }}>
                    <div className="col-md-4 col-12 align-center p-1 cursor" onClick={() => setSelectedTab(1)}
                        style={{ borderRadius: "2px", color: (SelectedTab === 1 ? "white" : "black"), backgroundColor: (SelectedTab === 1 ? "#005582" : "#ccc") }}>Customer Details </div>
                    <div className="col-md-4 col-12 align-center p-1 cursor" onClick={() => setSelectedTab(2)}
                        style={{ borderRadius: "2px", color: (SelectedTab === 2 ? "white" : "black"), backgroundColor: (SelectedTab === 2 ? "#005582" : "#ccc") }}>Goods Details</div>
                    <div className="col-md-4 col-12 align-center p-1 cursor" onClick={() => setSelectedTab(3)}
                        style={{ borderRadius: "2px", color: (SelectedTab === 3 ? "white" : "black"), backgroundColor: (SelectedTab === 3 ? "#005582" : "#ccc") }}>Insurance Details</div>

                    <div className="col-md-12 col-12" style={{ margin: "15px", visibility: (SelectedTab === 1 ? "visible" : "hidden"), height: (SelectedTab === 1 ? "60vh" : "0"), overflow: "auto" }}>
                        <table className="table surveyTable">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="text-field">
                                            <input tabIndex="1" autoFocus placeholder="" name="Name" value={customerData.Name}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span >Name<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field">
                                            <input tabIndex="11" placeholder="" name="CompanyName" value={customerData.CompanyName}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Company</span>
                                        </div>
                                    </td>
                                    <td style={{ verticalAlign: "top" }}>
                                        <div className="text-field">
                                            <input tabIndex="2" placeholder="" name="PhoneNumber" value={customerData.PhoneNumber > 0 ? customerData.PhoneNumber : ""}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Tel / Mobile Number<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ verticalAlign: "top" }}>
                                        <div className="text-field">
                                            <input tabIndex="3" placeholder="" name="EmailID" value={customerData.EmailID}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span >Email<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field">
                                            <textarea tabIndex="4" placeholder="" name="OriginAddress" value={customerData.OriginAddress}
                                                onChange={(e) => onTextChange(e)} rows="1" style={{ resize: "none", overflow: "auto" }}
                                                type="text"></textarea>
                                            <span>Origin Address<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field">
                                            <textarea tabIndex="12" placeholder="" name="DestinationAddress" value={customerData.DestinationAddress}
                                                onChange={(e) => onTextChange(e)} rows="1" style={{ resize: "none", overflow: "auto" }}
                                                type="text"></textarea>
                                            <span>Destination Address<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>


                                </tr>

                                <tr>
                                    <td>
                                        <div className="text-field">
                                            <input tabIndex="5" placeholder="" name="OriginCountry" value={customerData.OriginCountry}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Origin Country<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field">
                                            <input tabIndex="6" placeholder="" name="OriginState" value={customerData.OriginState}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Origin State<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field">
                                            <input tabIndex="7" placeholder="" name="OriginCity" value={customerData.OriginCity}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Origin City<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>


                                </tr>
                                <tr>
                                    <td>
                                        <div className="text-field">
                                            <input tabIndex="16" placeholder="" name="DestinationCountry" value={customerData.DestinationCountry}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Destination Country<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field">
                                            <input tabIndex="14" placeholder=" " name="DestinationState" value={customerData.DestinationState}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Destination State<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field">
                                            <input tabIndex="13" placeholder="" name="DestinationCity" value={customerData.DestinationCity}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span >Destination City<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="text-field">
                                            <input tabIndex="8" placeholder="" name="OriginPincode" value={customerData.OriginPincode > 0 ? customerData.OriginPincode : ""}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span >Origin Pincode<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field" >
                                            <input tabIndex="15" placeholder="" name="DestinationPincode" value={customerData.DestinationPincode > 0 ? customerData.DestinationPincode : ""}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Destination Pincode<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field" style={{ padding: "10px" }}>
                                            <DatePicker className="TextInputStyle datepicker"
                                                onChange={onPackingDateChange}
                                                selected={customerData.PreferredPackingDate}
                                                name="PreferredPackingDate"
                                                showTimeSelect
                                                timeIntervals={15}
                                                timeCaption="time"
                                                dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                                            <span style={{ display: (customerData.PreferredPackingDate !== null ? "none" : "block") }} className="datepickerPacking floating-span">Preferred Packing Date<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>

                                </tr>
                                <tr>
                                    <td style={{ display: "flex", justifyContent: "center" }}>
                                        <div style={{ width: "100%" }}>
                                            <Select isClearable={true} isSearchable={true} placeholder="Select Service Type *"
                                                options={Destination} value={ServiceType.value === null ? '' : ServiceType}
                                                onChange={OnDestinationChange}></Select>
                                        </div>
                                    </td>
                                    <td style={{ verticalAlign: "top" }}>
                                        <div className="text-field">
                                            <input tabIndex="9" placeholder="" name="OriginFloor" value={customerData.OriginFloor > 0 ? customerData.OriginFloor : 0}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span >Origin Floor<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field" style={{ padding: "10px" }}>
                                            <DatePicker className="TextInputStyle datepicker"
                                                selected={customerData.PreferredDeliveryDate}
                                                onChange={onDeliveryDateChange}
                                                name="PreferredDeliveryDate"
                                                showTimeSelect
                                                timeIntervals={15}
                                                timeCaption="time"
                                                dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                                            <span style={{ display: (customerData.PreferredDeliveryDate !== null ? "none" : "block") }} className="datepickerDelivery floating-span">Preferred Delivery Date<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div style={{ padding: "10px 0 0 20px" }}>
                                            <div className="switch">
                                                <input name="IBAApproval"
                                                    checked={(customerData.IBAApproval !== undefined && customerData.IBAApproval === 1)}
                                                    onChange={e => OnLiftAvailableChange(e)} id="switch3"
                                                    type="checkbox" className="switch-input" />
                                                <label htmlFor="switch3" className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>IBA Approval</span>
                                        </div>
                                    </td>

                                    <td>
                                        <div className="text-field">
                                            <input tabIndex="10" placeholder="" name="DesinationFloor" value={customerData.DesinationFloor > 0 ? customerData.DesinationFloor : 0}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Desination Floor<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="text-field" style={{ padding: "10px" }}>
                                            <DatePicker className="TextInputStyle datepicker"
                                                onChange={onMovingDateChange}
                                                selected={customerData.PreferredMovingDate}
                                                name="PreferredMovingDate"
                                                showTimeSelect
                                                timeIntervals={15}
                                                timeCaption="time"
                                                dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                                            <span style={{ display: (customerData.PreferredMovingDate !== null ? "none" : "block") }} className="datepickerMoving floating-span">Preferred Moving Date<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div style={{ padding: "10px 0 0 20px" }}>
                                            <div className="switch">
                                                <input checked={customerData.IsGSTAvailable === 1} name="IsGSTAvailable"
                                                    onChange={e => OnGSTCheckChange(e)} id="switch5"
                                                    type="checkbox" className="switch-input" />
                                                <label htmlFor="switch5" className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>Is GST Available ?</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ padding: "10px 0 0 20px" }}>
                                            <div className="switch">
                                                <input name="OriginHasLift"
                                                    checked={customerData.OriginHasLift === 1}
                                                    onChange={e => OnLiftAvailableChange(e)} id="switch1"
                                                    type="checkbox" className="switch-input" />
                                                <label htmlFor="switch1" className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>Origin Lift Available ?</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div style={{ padding: "10px 0 0 20px" }}>
                                            <div className="switch">
                                                <input name="DestinationHasLift"
                                                    checked={customerData.DestinationHasLift === 1}
                                                    onChange={e => OnLiftAvailableChange(e)} id="switch2"
                                                    type="checkbox" className="switch-input" />
                                                <label htmlFor="switch2" className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>Destination Lift Available ?</span>
                                        </div>

                                    </td>
                                </tr>
                                {customerData.IsGSTAvailable === 1 && (<tr>
                                    <td>
                                        <div className="text-field">
                                            <input disabled={customerData.IsGSTAvailable === 0} tabIndex="8" placeholder="" name="GSTNumber" value={customerData.GSTNumber}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>GST Number<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-md-12 col-12" style={{ visibility: (SelectedTab === 2 ? "visible" : "hidden"), height: (SelectedTab === 2 ? "100%" : "0") }}>
                        <div className="row" style={{ borderBottom: "1px solid #ccc", padding: "5px", marginBottom: "10px" }}>
                            <div className="col-md-4 col-sm-4 align-center">
                                <h3>
                                    Vehicle Load : {VehicleRequired}
                                </h3>
                            </div>
                            <div className="col-md-4 col-sm-4 align-center">
                                <h3>
                                    Total CFT : {CFTTotal}
                                </h3>
                            </div>
                            <div className="col-md-4 col-sm-4 col-12" style={{ display: "flex" }}>
                                <input type="text" name="Name" placeholder="Search Goods..."
                                    className="form-control" style={{ marginRight: "10px", borderRadius: "20px", paddingLeft: "50px" }}
                                    onChange={e => onGoodsSearch(e.target.value)}></input>
                                <div className={`${CurrentTheme}Color`} style={{ fontSize: "1rem", position: "absolute", left: "9%", top: "17%" }}>
                                    <FontAwesomeIcon icon={faSearch} />
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{ height: "50vh", overflow: "auto" }}>
                            {SearchOption === 0 && (<div className="col-md-12 col-sm-12">
                                <div className="align-center">
                                    <div style={{
                                        boxShadow: "0 0 4px #005582", borderRadius: "6px",
                                        cursor: "pointer", margin: "5px", padding: "6px"
                                    }} onClick={OnFunitureClick}>
                                        <h5 style={{ fontWeight: "500", paddingTop: "8px", color: "#005582" }}>Furniture Goods</h5>
                                    </div>
                                    <div style={{ display: FurnitureDisplay }}>
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{ minWidth: "200px", position: "initial" }}>Goods</th>
                                                    <th style={{ position: "initial" }}>Remarks</th>
                                                    <th style={{ position: "initial" }}>CFT</th>
                                                    <th style={{ position: "initial" }}>QTY</th>
                                                    <th style={{ position: "initial" }}>Total CFT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Goods.Furniture.length > 0 && Goods.Furniture.map(furniture => (
                                                    <tr key={furniture.ID}>
                                                        <td><div>{furniture.Text}</div></td>
                                                        <td><div><textarea className="form-control" style={{ resize: "none", margin: "auto", width: "60%" }}
                                                            id={`Remark${furniture.ID}`} rows="1"></textarea></div></td>
                                                        <td><div>{furniture.CFT}</div></td>
                                                        <td><div><input id={`qty${furniture.ID}`} name={furniture.Name} goodsid={furniture.ID}
                                                            cft={furniture.CFT}
                                                            onChange={OnQuantityChange}
                                                            value={GoodsState.filter(g => g.GoodsID === furniture.ID).length > 0 ? GoodsState.filter(g => g.GoodsID === furniture.ID)[0].Quantity : ""}
                                                            style={{
                                                                minWidth: "15%", maxWidth: "18%",
                                                                border: "1px solid #ccc", borderRadius: "6px",
                                                                padding: "5px", textAlign: "center"
                                                            }} type="text"></input></div></td>
                                                        <td><div className="cftData" id={`cft${furniture.ID}`}>{GoodsState.filter(g => g.GoodsID === furniture.ID).length > 0 ? GoodsState.filter(g => g.GoodsID === furniture.ID)[0].CFTValue * GoodsState.filter(g => g.GoodsID === furniture.ID)[0].Quantity : 0}</div></td>
                                                    </tr>))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>)}
                            {SearchOption === 0 && (<div className="col-md-12 col-sm-12">
                                <div className="align-center">
                                    <div style={{
                                        boxShadow: "0 0 4px #005582", borderRadius: "6px",
                                        cursor: "pointer", margin: "5px", padding: "6px"
                                    }} onClick={OnElectronicsClick}>
                                        <h5 style={{ fontWeight: "500", paddingTop: "8px", color: "#005582" }}>Electronics Goods</h5>
                                    </div>
                                    <div style={{ display: ElectronicsDisplay }}>
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{ minWidth: "200px", position: "initial" }}>Goods</th>
                                                    <th style={{ position: "initial" }}>Remarks</th>
                                                    <th style={{ position: "initial" }}>CFT</th>
                                                    <th style={{ position: "initial" }}>QTY</th>
                                                    <th style={{ position: "initial" }}>Total CFT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Goods.Electronics.length > 0 && Goods.Electronics.map(electronics => (
                                                    <tr key={electronics.ID}>
                                                        <td><div>{electronics.Text}</div></td>
                                                        <td><div><textarea className="form-control" style={{ resize: "none", margin: "auto", width: "60%" }}
                                                            id={`Remark${electronics.ID}`} rows="1"></textarea></div></td>
                                                        <td><div>{electronics.CFT}</div></td>
                                                        <td><div><input name={electronics.Name} goodsid={electronics.ID} cft={electronics.CFT}
                                                            onChange={OnQuantityChange}
                                                            value={GoodsState.filter(g => g.GoodsID === electronics.ID).length > 0 ? GoodsState.filter(g => g.GoodsID === electronics.ID)[0].Quantity : ""}
                                                            style={{
                                                                minWidth: "15%", maxWidth: "18%", textAlign: "center",
                                                                border: "1px solid #ccc", borderRadius: "6px", padding: "5px"
                                                            }} type="text"></input></div></td>
                                                        <td><div className="cftData" id={`cft${electronics.ID}`}>
                                                            {GoodsState.filter(g => g.GoodsID === electronics.ID).length > 0 ? GoodsState.filter(g => g.GoodsID === electronics.ID)[0].CFTValue * GoodsState.filter(g => g.GoodsID === electronics.ID)[0].Quantity : 0}</div></td>
                                                    </tr>))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>)}
                            {SearchOption === 0 && (<div className="col-md-12 col-sm-12">
                                <div className="align-center">
                                    <div style={{
                                        boxShadow: "0 0 4px #005582", borderRadius: "6px",
                                        cursor: "pointer", margin: "5px", padding: "6px"
                                    }} onClick={OnBedRoomClick}>
                                        <h5 style={{ fontWeight: "500", paddingTop: "8px", color: "#005582" }}>Bed Room Goods</h5>
                                    </div>
                                    <div style={{ display: BedRoomDisplay }}>
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{ minWidth: "200px", position: "initial" }}>Goods</th>
                                                    <th style={{ position: "initial" }}>Remarks</th>
                                                    <th style={{ position: "initial" }}>CFT</th>
                                                    <th style={{ position: "initial" }}>QTY</th>
                                                    <th style={{ position: "initial" }}>Total CFT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Goods.BedRoom.length > 0 && Goods.BedRoom.map(bedroom => (
                                                    <tr key={bedroom.ID}>
                                                        <td><div>{bedroom.Text}</div></td>
                                                        <td><div><textarea className="form-control" style={{ resize: "none", margin: "auto", width: "60%" }}
                                                            id={`Remark${bedroom.ID}`} rows="1"></textarea></div></td>
                                                        <td><div>{bedroom.CFT}</div></td>
                                                        <td><div><input name={bedroom.Name} goodsid={bedroom.ID} cft={bedroom.CFT}
                                                            onChange={OnQuantityChange}
                                                            value={GoodsState.filter(g => g.GoodsID === bedroom.ID).length > 0 ? GoodsState.filter(g => g.GoodsID === bedroom.ID)[0].Quantity : ""}
                                                            style={{
                                                                minWidth: "15%",
                                                                maxWidth: "18%", textAlign: "center", border: "1px solid #ccc",
                                                                borderRadius: "6px", padding: "5px"
                                                            }} type="text"></input></div></td>
                                                        <td><div className="cftData" id={`cft${bedroom.ID}`}>
                                                            {GoodsState.filter(g => g.GoodsID === bedroom.ID).length > 0 ? GoodsState.filter(g => g.GoodsID === bedroom.ID)[0].CFTValue * GoodsState.filter(g => g.GoodsID === bedroom.ID)[0].Quantity : 0}
                                                        </div></td>
                                                    </tr>))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>)}
                            {SearchOption === 0 && (<div className="col-md-12 col-sm-12">
                                <div className="align-center">
                                    <div style={{
                                        boxShadow: "0 0 4px #005582", borderRadius: "6px",
                                        cursor: "pointer", margin: "5px", padding: "6px"
                                    }} onClick={OnOthersClick}>
                                        <h5 style={{ fontWeight: "500", paddingTop: "8px", color: "#005582" }}>Other Goods</h5>
                                    </div>
                                    <div>
                                        <div style={{ display: OthersDisplay }}>
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th style={{ minWidth: "200px", position: "initial" }}>Goods</th>
                                                        <th style={{ position: "initial" }}>Remarks</th>
                                                        <th style={{ position: "initial" }}>CFT</th>
                                                        <th style={{ position: "initial" }}>QTY</th>
                                                        <th style={{ position: "initial" }}>Total CFT</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Goods.Others.length > 0 && Goods.Others.map(Other => (
                                                        <tr key={Other.ID}>
                                                            <td><div>{Other.Text}</div></td>
                                                            <td><div><textarea className="form-control" style={{ resize: "none", margin: "auto", width: "60%" }}
                                                                id={`Remark${Other.ID}`} rows="1"></textarea></div></td>
                                                            <td><div>{Other.CFT}</div></td>
                                                            <td><div><input name={Other.Name} goodsid={Other.ID} cft={Other.CFT}
                                                                onChange={OnQuantityChange}
                                                                value={GoodsState.filter(g => g.GoodsID === Other.ID).length > 0 ? GoodsState.filter(g => g.GoodsID === Other.ID)[0].Quantity : ""}
                                                                style={{
                                                                    minWidth: "15%", maxWidth: "18%",
                                                                    textAlign: "center", border: "1px solid #ccc",
                                                                    borderRadius: "6px", padding: "5px"
                                                                }} type="text"></input></div></td>
                                                            <td><div className="cftData" id={`cft${Other.ID}`}>
                                                                {GoodsState.filter(g => g.GoodsID === Other.ID).length > 0 ? GoodsState.filter(g => g.GoodsID === Other.ID)[0].CFTValue * GoodsState.filter(g => g.GoodsID === Other.ID)[0].Quantity : 0}
                                                            </div></td>
                                                        </tr>))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>)}
                            {SearchOption === 1 && (<div className="col-md-12 col-sm-12">
                                <div className="align-center">
                                    <div>
                                        <table className="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{ minWidth: "200px", position: "initial" }}>Goods</th>
                                                    <th style={{ position: "initial" }}>Remarks</th>
                                                    <th style={{ position: "initial" }}>CFT</th>
                                                    <th style={{ position: "initial" }}>QTY</th>
                                                    <th style={{ position: "initial" }}>Total CFT</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {SearchGoods.length > 0 && SearchGoods.map(furniture => (
                                                    <tr key={furniture.ID}>
                                                        <td><div>{furniture.Text}</div></td>
                                                        <td><div><textarea className="form-control" style={{ resize: "none", margin: "auto", width: "60%" }}
                                                            id={`Remark${furniture.ID}`} rows="1"></textarea></div></td>
                                                        <td><div>{furniture.CFT}</div></td>
                                                        <td><div><input id={`qty${furniture.ID}`} name={furniture.Name} goodsid={furniture.ID}
                                                            cft={furniture.CFT}
                                                            onChange={OnQuantityChange}
                                                            value={GoodsState.filter(g => g.GoodsID === furniture.ID).length > 0 ? GoodsState.filter(g => g.GoodsID === furniture.ID)[0].Quantity : ""}
                                                            style={{
                                                                minWidth: "15%", maxWidth: "18%",
                                                                border: "1px solid #ccc", borderRadius: "6px",
                                                                padding: "5px", textAlign: "center"
                                                            }} type="text"></input></div></td>
                                                        <td><div className="cftData" id={`cft${furniture.ID}`}>{GoodsState.filter(g => g.GoodsID === furniture.ID).length > 0 ? GoodsState.filter(g => g.GoodsID === furniture.ID)[0].CFTValue * GoodsState.filter(g => g.GoodsID === furniture.ID)[0].Quantity : 0}</div></td>
                                                    </tr>))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>)}
                        </div>
                    </div>
                    <div className="col-md-12 col-sm-12 col-12" style={{ visibility: (SelectedTab === 3 ? "visible" : "hidden"), overflow: "auto", height: (SelectedTab === 3 ? "60vh" : "0") }}>
                        <div className="row">
                            <div className="col-md-12 col-sm-12" style={{ marginTop: "20px" }}>
                                <div>
                                    <h6 style={{ paddingRight: "20px" }}>
                                        <span className="mandatoryStar">*</span>
                                        Not opting for insurance will subject to the risk not covered by the company.
                                        Company will not be liable for any Damages. Get Insured for hastle free Logistics
                                    </h6>
                                </div>
                                <h5>Insurance Required<span className="mandatoryStar">*</span></h5>
                                <div className="switch">
                                    <input checked={customerData.IsInsured === 1 ? true : false} name="IsInsured" id="switchInsurance" onChange={OnInsuranceChange} type="checkbox" className="switch-input" />
                                    <label htmlFor="switchInsurance" className="switch-label">Switch</label>
                                </div>
                            </div>
                            {customerData.IsInsured === 1 && (<div className="col-md-6 col-sm-12" style={{ marginTop: "20px" }}>
                                <h5 style={{ paddingRight: "20px" }}>Insurance Type<span className="mandatoryStar">*</span></h5>
                                <select className="DropdownStyle" value={customerData.InsuranceType} name="InsuranceType" onChange={OnInsuranceChange}>
                                    <option key={0} value="0">Select Type</option>
                                    <option key={1} value="1">Transit Risk</option>
                                    <option key={2} value="2">Carrier Risk</option>
                                </select>
                            </div>)}
                            {customerData.IsInsured === 1 && (<div className="col-md-6 col-sm-12" style={{ marginTop: "20px" }}>
                                <h5 style={{ paddingRight: "20px" }}>Insured Amount<span className="mandatoryStar">*</span></h5>
                                <input style={{ width: "60%" }} value={customerData.InsuranceAmount} name="InsuranceAmount" onChange={OnInsuranceChange} className="form-control" type="text"></input>
                            </div>)}
                        </div>
                    </div>
                </div >
            </div >

            {/* show preview  of survey*/}
            {displaySurveyPreview === "block" && (<SurveyPreview CurrentTheme={CurrentTheme}
                GoodsState={GoodsState} CFTTotal={CFTTotal} VehicleRequired={VehicleRequired}
                hideSurveyPreview={hideSurveyPreview}></SurveyPreview>)}

            {/* show Vehicle Chart*/}
            {displayVehicleChart === "block" && (<SurveyVehicleChart CurrentTheme={CurrentTheme}
                VehicleChart={VehicleChart} hideVehicleChart={hideVehicleChart}></SurveyVehicleChart>)}
        </div >
    );
};

export default Survey;